import * as React from "react";
import {connect} from "react-redux";
import {
    approveLocationals,
    ApproveLocationals

} from "../actions";
import * as selectors from "../selectors";
import LocationalState, {LocationalRoadObject} from "../LocationalState";

interface TagProps {

}

interface DispatchProps {
    doApproveLocationals: ApproveLocationals,

}

interface StateProps {
    selectedLocationalsAreApproveable: boolean,
    selectedRoadObjects: LocationalRoadObject[],
}


type Props = TagProps & StateProps & DispatchProps;

const mapStateToProps = (state: LocationalState): StateProps => {
    return {
        selectedLocationalsAreApproveable: selectors.selectedLocationalsAreApproveable(state),
        selectedRoadObjects: selectors.selectedRoadObjects(state),
    };
};

const mapDispatchToProps: DispatchProps = ({
    doApproveLocationals: approveLocationals,
});

class Component extends React.Component<Props, {}> {

    render(){
        const {selectedLocationalsAreApproveable} = this.props;
        return (
            <div className={"approveLocationalTool"}>
                <button className={"btn"} onClick={() => this.handleClick()} disabled={!selectedLocationalsAreApproveable} >Godkjenn valgte stedfestinger</button>
            </div>
        );
    }

    handleClick() {
        this.props.doApproveLocationals(this.props.selectedRoadObjects)
    };

}

export const ApproveLocationalsTool = connect(mapStateToProps, mapDispatchToProps)(Component);